import { render, staticRenderFns } from "./income.vue?vue&type=template&id=08f8ad19&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=08f8ad19&lang=scss&scoped=true&"
import style1 from "./income.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./income.vue?vue&type=style&index=2&id=08f8ad19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8ad19",
  null
  
)

export default component.exports